import { Container } from './card';
import * as Content from './content';
import * as Footer from './footer';
import * as Header from './header';

export const EventCard = {
  Container,
  H: Header,
  C: Content,
  F: Footer,
};
